import React from 'react';
import { useAuth } from '../auth/AuthContext';
import { Link } from 'react-router-dom';
import '../admin/Admin.css';

export default function AdminDashboard() {
  const { user } = useAuth();

  const stats = [
    { label: 'Utilisateurs', count: '-', icon: '👥', link: '/admin/users', color: '#6366f1' },
    { label: 'Références', count: '-', icon: '📁', link: '/admin/references', color: '#0ea5e9' },
    { label: 'Société', count: '-', icon: '🏢', link: '/admin/societe', color: '#10b981' },
    { label: 'Métiers', count: '-', icon: '🎓', link: '/admin/metiers', color: '#ec4899' },
    { label: 'Recrutement', count: '-', icon: '💼', link: '/admin/recrutement', color: '#8b5cf6' },
    { label: 'Services', count: '-', icon: '🛠️', link: '/admin/services', color: '#f59e0b' },
  ];

  return (
    <section className="section">
      <div className="section-inner" style={{ maxWidth: 1200 }}>
        <div className="section-header" style={{ marginBottom: '2rem' }}>
          <h1 className="admin-title-gradient">Tableau de Bord</h1>
          <p style={{ fontSize: '1.1rem', color: 'var(--admin-text-muted)' }}>
            Bienvenue, <span style={{ color: 'var(--admin-text)', fontWeight: 600 }}>{user?.name || user?.email}</span>.
            Prêt à gérer votre contenu ?
          </p>
        </div>

        <div className="admin-stats-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '1.5rem',
          marginBottom: '3rem'
        }}>
          {stats.map((item, idx) => (
            <Link key={idx} to={item.link} className="card admin-stat-card" style={{
              textDecoration: 'none',
              transition: 'transform 0.2s, box-shadow 0.2s',
              borderLeft: `4px solid ${item.color}`
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <div style={{ fontSize: '0.9rem', color: 'var(--admin-text-muted)', marginBottom: '0.5rem' }}>{item.label}</div>
                  <div style={{ fontSize: '2rem', fontWeight: 800, color: 'var(--admin-text)' }}>{item.count}</div>
                </div>
                <div style={{ fontSize: '2.5rem', opacity: 0.2 }}>{item.icon}</div>
              </div>
              <div style={{ marginTop: '1rem', fontSize: '0.85rem', color: item.color, fontWeight: 600 }}>
                Gérer →
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-2" style={{ gap: '2rem' }}>
          <article className="card" style={{ padding: '2rem' }}>
            <h3 style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <span>🚀</span> Actions Rapides
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1.5rem' }}>
              <Link to="/admin/references/new" className="btn btn-primary" style={{ textAlign: 'center' }}>+ Ajouter une Référence</Link>
              <Link to="/admin/societe" className="btn btn-outline" style={{ textAlign: 'center' }}>Gérer le contenu "Société"</Link>
              <Link to="/admin/metiers" className="btn btn-outline" style={{ textAlign: 'center' }}>Gérer les Métiers & Expertises</Link>
              <Link to="/admin/hero-slides" className="btn btn-outline" style={{ textAlign: 'center' }}>Modifier les Slides d'Accueil</Link>
            </div>
          </article>

          <article className="card" style={{ padding: '2rem' }}>
            <h3 style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <span>📢</span> Support & Aide
            </h3>
            <p style={{ color: 'var(--admin-text-muted)', lineHeight: 1.6 }}>
              Si vous rencontrez des difficultés avec l'interface d'administration,
              consultez le guide utilisateur ou contactez l'équipe technique.
            </p>
            <div style={{ marginTop: '1.5rem', display: 'flex', gap: '1rem' }}>
              <button disabled className="btn btn-sm btn-ghost" style={{ cursor: 'not-allowed', opacity: 0.5 }}>Guide (PDF)</button>
              <Link to="/contact" className="btn btn-sm btn-secondary">Support</Link>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
